module.exports = __webpack_public_path__ + "static/media/document-week1.37c3e0aa.pdf";